import React from 'react';
import * as S from './Styled';

const Container = ({ children, ...rest }) => (
  <S.Container {...rest}>{children}</S.Container>
);

export default Container;
